<template>
  <div class="UserForm">
    <form
      class="form"
      method="post"
      :action="formAction"
      @submit.prevent="submit"
      v-if="!sentData"
    >
      <h4 class="subTitle">
        SCRIVI QUALCOSA SUL RESPONSABILE DI PROGETTO
      </h4>
      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.choice_1.label }}</label>
          </div>
          <div class="field">
            <div class="customSelectWrapper">
              <select
                class="customSelect"
                name="choice_1"
                @change="setField"
                v-model="project.choice_1.value"
              >
                <option v-for="o in project.choice_1.options" :value="o.value">
                  {{ o.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.choice_1" v-html="errors.choice_1"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.choice_2.label }}</label>
          </div>
          <div class="field">
            <div class="customSelectWrapper">
              <select
                class="customSelect"
                name="choice_2"
                @change="setField"
                v-model="project.choice_2.value"
              >
                <option v-for="o in project.choice_2.options" :value="o.value">
                  {{ o.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.choice_2" v-html="errors.choice_2"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.company.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="company"
              class="textInput"
              v-model="project.company.value"
              @input="setField"
              :placeholder="project.company.placeholder"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.company" v-html="errors.company"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.choice_4.label }}</label>
          </div>
          <div class="field">
            <div class="customSelectWrapper">
              <select
                class="customSelect"
                name="choice_4"
                @change="setField"
                v-model="project.choice_4.value"
              >
                <option v-for="o in project.choice_4.options" :value="o.value">
                  {{ o.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.choice_4" v-html="errors.choice_4"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.first_name.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="first_name"
              @input="setField"
              class="textInput"
              :placeholder="project.first_name.placeholder"
              v-model="project.first_name.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.first_name" v-html="errors.first_name"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.last_name.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="last_name"
              @input="setField"
              class="textInput"
              :placeholder="project.last_name.placeholder"
              v-model="project.last_name.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.last_name" v-html="errors.last_name"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.birthdate.label }}*</label>
          </div>
          <div class="field">
            <date-picker
              v-model="project.birthdate.value"
              @input="setBirthDate"
              :input-props="{
                class: 'textInput',
                placeholder: project.birthdate.label,
                readonly: true
              }"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.birthdate" v-html="errors.birthdate"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.birthplace.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="birthplace"
              @input="setField"
              class="textInput"
              :placeholder="project.birthplace.placeholder"
              v-model="project.birthplace.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.birthplace" v-html="errors.birthplace"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.fiscal_code.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="fiscal_code"
              @input="setField"
              class="textInput"
              :placeholder="project.fiscal_code.placeholder"
              v-model="project.fiscal_code.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span
                v-if="errors.fiscal_code"
                v-html="errors.fiscal_code"
              ></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.address.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="address"
              @input="setField"
              class="textInput"
              :placeholder="project.address.placeholder"
              v-model="project.address.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.address" v-html="errors.address"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.email.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="email"
              @input="setField"
              class="textInput"
              :placeholder="project.email.placeholder"
              v-model="project.email.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.email" v-html="errors.email"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.phone.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="phone"
              @input="setField"
              class="textInput"
              :placeholder="project.phone.placeholder"
              v-model="project.phone.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.phone" v-html="errors.phone"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.file_3.label }}</label>
          </div>
          <div class="field d-flex">
            <input type="file" name="file_3" @change="onProjectCardChange" />
            <div class="textInput">
              <span
                v-html="!!file_3 ? file_3.name : project.file_3.placeholder"
              ></span>
            </div>
            <div class="fileBtn"></div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.file_3" v-html="errors.file_3"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>

        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.file_4.label }}</label>
          </div>
          <div class="field d-flex">
            <input type="file" name="file_4" @change="onProjectCardChange" />
            <div class="textInput">
              <span
                v-html="!!file_4 ? file_4.name : project.file_4.placeholder"
              ></span>
            </div>
            <div class="fileBtn"></div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.file_4" v-html="errors.file_4"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <h4 class="subTitle">
        SCRIVI QUALCOSA SULL’ORGANIZZAZIONE DEL PROGETTO
      </h4>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.choice_3.label }}</label>
          </div>
          <div class="field">
            <div class="customSelectWrapper">
              <select
                class="customSelect"
                name="choice_3"
                @change="setField"
                v-model="project.choice_3.value"
              >
                <option v-for="o in project.choice_3.options" :value="o.value">
                  {{ o.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.choice_3" v-html="errors.choice_3"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>

        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.file_1.label }}</label>
          </div>
          <div class="field d-flex">
            <input type="file" name="file_1" @change="onProjectCardChange" />
            <div class="textInput">
              <span
                v-html="!!file_1 ? file_1.name : project.file_1.placeholder"
              ></span>
            </div>
            <div class="fileBtn"></div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.file_1" v-html="errors.file_1"></span>
            </div>
            <div class="info">
              Se il tuo team è composto da più persone carica un unico file PDF
              che comprende tutti i CV del team. Puoi usare programmi gratuiti
              come "
              <a href="https://smallpdf.com/" target="_blank">small PDF</a>
              ".
            </div>
          </div>
        </div>
      </div>

      <h4 class="subTitle">
        DESCRIVI SINTETICAMENTE IL PROGETTO E POI CARICA LA SCHEDA COMPLETA
      </h4>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>{{ project.title.label }}</label>
          </div>
          <div class="field">
            <input
              type="text"
              name="title"
              @input="setField"
              class="textInput"
              :placeholder="project.title.placeholder"
              v-model="project.title.value"
            />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="$v.title.$error">Campo obbligatorio</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>{{ project.description.label }}</label>
          </div>
          <div class="field">
            <textarea
              name="description"
              @input="setField"
              class="textInput"
              :placeholder="project.description.placeholder"
              v-model="project.description.value"
            ></textarea>
          </div>
          <div class="msg">
            <div class="error">
              <span
                v-if="errors.description"
                v-html="errors.description"
              ></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>{{ project.file_2.label }}</label>
          </div>
          <div class="field d-flex">
            <input type="file" name="file_2" @change="onProjectCardChange" />
            <div class="textInput">
              <span
                v-html="!!file_2 ? file_2.name : project.file_2.placeholder"
              ></span>
            </div>
            <div class="fileBtn"></div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.file_2" v-html="errors.file_2"></span>
            </div>
            <div class="info">
              Il template della scheda progetto puoi scaricarlo
              <a
                href="https://bicocca-network.servercdn.it/media/Bicocca__scheda_progetto.pdf"
                target="_blank"
              >
                qui
              </a>
              . Ricordati di rispondere a tutte le richieste del bando. Carica
              il documento in formato PDF per massimo 4 pagine, carattere minimo
              utilizzabile 10 punti.
            </div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.budget_required.label }}</label>
          </div>

          <div class="field">
            <div class="flexWrapper">
              <input
                type="text"
                name="budget_required"
                @input="setField"
                class="textInput"
                :placeholder="project.budget_required.placeholder"
                v-model="project.budget_required.value"
              />
              <div class="input-group-addon">&euro;</div>
            </div>
          </div>
          <div class="msg">
            <div class="error">
              <span
                v-if="errors.budget_required"
                v-html="errors.budget_required"
              ></span>
            </div>
            <div class="info">
              Ricorda: se il tuo progetto sarà selezionato, riceverai un
              finanziamento solo se raccoglierai, in crowdfunding, almeno il 50%
              del budget in modalità “tutto o niente”.
            </div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{ project.budget_prospectus.label }}</label>
          </div>
          <div class="field d-flex">
            <input
              type="hidden"
              name="name_budget_prospectus"
              :value="name_budget_prospectus"
            />
            <input
              type="file"
              name="budget_prospectus"
              @change="onProjectCardChange"
            />
            <div class="textInput">
              <span
                v-html="
                  !!budget_prospectus
                    ? budget_prospectus.name
                    : project.budget_prospectus.placeholder
                "
              ></span>
            </div>
            <div class="fileBtn"></div>
          </div>
          <div class="msg">
            <div class="error">
              <span
                v-if="errors.budget_prospectus"
                v-html="errors.budget_prospectus"
              ></span>
            </div>
            <div class="info">
              Se desideri puoi integrare il budget descritto nella scheda
              progetto con un file Excel.
            </div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>Regolamento*</label>
          </div>
          <div class="overflowWrapper">
            <div class="overflowContent" v-html="rules"></div>
          </div>
          <div class="msg"></div>
        </div>
      </div>

      <!-- 
      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input id="id_policy" type="checkbox" name="policy" v-model="policy" />
            <label for="id_policy" class="label" v-html="project.policy.label">
            </label>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="$v.policy.$invalid">{{ errors.policy }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      
      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input id="id_accept_rule_yes" type="radio" name="accept_rule" :value="true" v-model="$v.accept_rule.$model" />
            <label for="id_accept_rule_yes" class="label"  v-html="project.accept_rule_yes.label" >
            </label>
          </div>
          <div class="msg">
            <div class="info"></div>
          </div>
        </div>
      </div>
      

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input id="id_accept_rule_no" type="radio" name="accept_rule" :value="false" v-model="$v.accept_rule.$model" />
            <label for="id_accept_rule_no" class="label"  v-html="project.accept_rule_no.label" >
            </label>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="$v.accept_rule.$invalid">{{ errors.accept_rule }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>
      -->

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input
              id="id_accept_rule"
              type="checkbox"
              name="accept_rule"
              @change="setField"
              v-model="project.accept_rule.value"
            />
            <label
              for="id_accept_rule"
              class="label"
              v-html="project.accept_rule.label"
            ></label>
          </div>
          <div class="msg">
            <div class="error">
              <span
                v-if="$v.accept_rule.$invalid"
                v-html="errors.accept_rule"
              ></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <!-- 
      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input id="id_newsletter" type="checkbox" name="newsletter" :value="false" v-model="newsletter" />
            <label for="id_newsletter" class="label"  v-html="project.newsletter.label" >
            </label>
          </div>
          <div class="msg">
            <div class="info"></div>
          </div>
        </div>
      </div>
      -->
      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <button
            class="saveDraft"
            type="button"
            @click.prevent="onSaveDraftBtnClick"
          >
            Salva la bozza
          </button>
          <div class="msg">
            <div class="info">
              Potrai accedere nuovamente alle informazioni salvate fino a questo
              momento. Il link unico verrà inviato all’indirizzo email che hai
              fornito sopra.
            </div>
          </div>
        </div>

        <input type="hidden" name="uuid" v-model="project.uuid.value" />
        <div class="fieldWrapper flex50">
          <input type="submit" value="Invia la tua idea" />
          <div class="msg">
            <div class="error">
              <span v-if="!!globalErrorMsg" v-html="globalErrorMsg"></span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import { mapState, mapActions } from 'vuex';

import DatePicker from 'v-calendar/lib/components/date-picker.umd';

import GenericBigText from './generic_big_text';

import {
  required,
  requiredIf,
  email,
  integer,
  numeric,
  sameAs,
  maxLength,
  maxValue
} from 'vuelidate/lib/validators';

import { helpers } from 'vuelidate/lib/validators';

import { checkIfSet } from '../mixins/check_if_set';

import { validationMixin } from 'vuelidate';

import '@images/upload.svg';

import EventBus from '../views/event_bus';

const regexValidator = param =>
  helpers.withParams({ type: 'regex', value: param }, value => {
    return !helpers.req(value) || param.test(value.name);
  });

const fileSize = param =>
  helpers.withParams({ type: 'maxFileSize', value: param }, value => {
    // console.log(value, param, !helpers.req(value) || value.file.size < ( param * 1024 * 1024))
    return !helpers.req(value) || value.file.size < param * 1024 * 1024;
  });

export default {
  name: 'UserForm',
  components: {
    DatePicker,
    GenericBigText
  },
  mixins: [validationMixin],
  data() {
    return {
      first_name: null,
      last_name: null,
      birthdate: null,
      choice_1: null,
      choice_2: null,
      choice_3: null,
      choice_4:null,
      fiscal_code: null,
      birthplace: null,
      address: null,
      email: null,
      phone: null,
      title: null,
      description: null,
      budget_required: null,
      budget_prospectus: null,
      name_budget_prospectus: null,
      accept_rule: false,
      company: null,
      file_1: null,
      file_2: null,
      file_3: null,
      file_4: null,
      name_file_1: null,
      name_file_2: null,
      name_file_3: null,
      name_file_4: null,
      sentData: false,
      localProject: {},
      globalErrorMsg: ''
    };
  },
  props: {
    defaultErrorMsg: {
      type: String,
      default: 'Attenzione! Correggi gli errori nel form.'
    },
    defaultErrorRequest: {
      type: String,
      default: 'Errore di comunicazione con il server.'
    },
    formAction: {
      type: String,
      default: ''
    },
    getViewUrl: {
      type: String,
      default: ''
    },
    updateViewUrl: {
      type: String,
      default: ''
    },
    rules: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['project']),

    saveProjectUrl() {
      return !!this.project.uuid.value
        ? `${this.updateViewUrl}${this.project.uuid.value + '/'}`
        : this.formAction;
    },

    fields: function() {
      return Object.keys(this.project);
    },

    errors() {
      let obj = {},
        fields = Object.keys(this.localProject);
      fields.forEach(f => {
        let v = !!this.localProject[f].remoteError
          ? this.localProject[f].remoteError
          : !!this.$v[f] && !!this.$v[f].$error
          ? this.buildErrorMsg(f)
          : '';
        let o = {
          [f]: v
        };
        obj = { ...obj, ...o };
      });
      return obj;
    }
  },
  methods: {
    ...mapActions(['setProjectValues']),

    onSaveDraftBtnClick(e) {
      e.preventDefault();
      this.$v.email.$touch();
      if (!this.$v.email.$invalid) {
        EventBus.$emit('save-draft-modal', {
          userEmail: this.email,
          title: !!this.project.uuid.value
            ? 'Salva la bozza'
            : 'Accedi alla bozza',
          submitText: `Invia il link via mail e ${
            !!this.project.uuid.value ? 'salva' : 'accedi'
          }`
        });
      } else {
        let el = this.$el.querySelector(`[name=email]`);
        this.$nextTick(() => {
          el.focus();
        });
      }
    },

    getBase64(file, name) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        try {
          reader.readAsDataURL(file);
          reader.onload = () => {
            resolve({ name: name, result: reader.result });
          };
          reader.onerror = error => reject(error);
        } catch (err) {
          console.log(err);
          resolve({ name: null, result: null });
          // reject(err)
        }
      });
    },

    getFormData() {
      let obj = new FormData(),
        promises = [];

      return new Promise((resolve, reject) => {
        for (let k in this.$v) {
          console.log(k, !!this.$v[k] ? this.$v[k].$model : 'NONE');
          if (
            [
              'budget_prospectus',
              'file_1',
              'file_2',
              'file_3',
              'file_4'
            ].includes(k)
          ) {
            let f = this.$el.querySelector(`[name=${k}]`).files[0];
            if (!!f && !this[k].ghost) {
              promises.push(this.getBase64(f, k));
              obj.set(`name_${k}`, this[`name_${k}`]);
            }
          } else if (
            !!this.$v[k] &&
            (!!this.$v[k].$model ||
              (this.$v[k].$model !== null &&
                this.$v[k].$model !== '' &&
                this.$v[k].$model !== undefined))
          ) {
            obj.set(k, this.$v[k].$model);
          }
        }

        Promise.all(promises).then(resolved => {
          resolved.forEach(r => {
            console.log(`${r.name} resolved`);
            obj.set(r.name, r.result);
          });

          if (!!moment(obj.get('birthdate')).isValid()) {
            obj.set(
              'birthdate',
              moment(obj.get('birthdate')).format('YYYY-MM-DD')
            );
          }

          if (!!obj.get('budget_required')) {
            obj.set(
              'budget_required',
              obj.get('budget_required').replace(/,/g, '.')
            );
          }

          if (!!this.project.uuid.value) {
            obj.set('uuid', this.project.uuid.value);
          }

          if (!!this.company) {
            obj.set('company', this.company);
          }

          resolve(obj);
        });
      });
    },

    setBirthDate() {
      this.birthdate = this.project.birthdate.value;
      if (!!this.$v['birthdate']) {
        this.$v['birthdate'].$touch();
      }
    },

    setField(event) {
      const name = event.currentTarget.name;
      console.log(name, this.$v[name], this.project[name].value);
      this[name] = this.project[name].value;
      if (!!this.$v[name]) {
        this.$v[name].$touch();
      }
    },

    onProjectCardChange(e) {
      let field = e.currentTarget,
        f = field.files[0],
        regex = new RegExp(field.dataset.regex);

      this.project[field.name].value = f;
      this[field.name] = {
        ghost: false,
        name: f.name,
        file: f
      };

      this[`name_${field.name}`] = f.name;

      this.$v[field.name].$touch();
    },

    focusFirstStatus(component = this) {
      for (let i = 0; i < this.fields.length; i++) {
        let f = this.fields[i];
        let el = this.$el.querySelector(`[name=${f}]`);
        if (!!this.$v[f] && this.$v[f].$dirty && this.$v[f].$error) {
          el.focus();
          return;
        }
      }
    },

    onPolicyChange(e) {
      this.localProject.policy.value = e.target.checked;
      this.$v.policy.$touch();
    },

    buildErrorMsg(f) {
      let me = this,
        errors = [],
        field = this.$v[f];

      for (let k in field.$params) {
        let v = field.$params[k].type;
        if (field[v] === false) {
          errors.push(me.getErrorMessage(f, field.$params[k]));
        }
      }
      return errors.join('<br />');
    },

    getErrorMessage(field, param) {
      let f = param.type;
      if (!!this.localProject[field].localError) {
        return this.localProject[field].localError;
      } else {
        switch (f) {
          case 'required':
          case 'requiredIf':
            return 'Campo obbligatorio';

          case 'email':
            return 'E-mail non valida';

          case 'integer':
            return 'Valore non valido';

          case 'numeric':
            return 'Valore non valido';

          case 'sameAs':
            return 'Campo obbligatorio';

          case 'maxLength':
            return `Lunghezza massima: ${param.max} caratteri`;

          case 'maxValue':
            return `Valore massimo: ${param.max}€`;

          case 'regex':
            return `Formato non supportato`;

          case 'maxFileSize':
            return `Dimensione massima: ${param.value} MB`;

          default:
            return 'Valore non valido';
        }
      }
    },

    saveDraft({ email }) {
      let me = this;

      if (!window.PDB) {
        // Not in PDB, add Authorization header
        axios.defaults.headers.common['Authorization'] =
          'Token 427ac565f2cbda2371026e17af9394e9281a11fb';
      }

      me.getFormData().then(formData => {
        formData.set('is_published', false);
        formData.set('email_for_communications', email);
        //axios.post(me.formAction, formData, {
        //  //headers: {
        //  //  'Content-Type': 'multipart/form-data'
        //  //}
        axios({
          method: 'post',
          url: me.saveProjectUrl,
          data: formData
        })
          .then(response => {
            // me.sentData = true;
            me.project.uuid.value = response.data.uuid;
            me.$emit('draft-success');
            EventBus.$emit('draft-saved');
          })
          .catch(error => {
            let msg = '';

            switch (error.response.status) {
              case 403:
                msg = JSON.parse(error.response.data.error).detail;

                break;
              case 400:
                let obj = JSON.parse(error.response.data.error);

                Object.keys(obj).forEach(k => {
                  msg += `${this.project[k].label}: ${obj[k].join(
                    ', '
                  )} <br />`;
                });
                break;
              default:
                msg = 'Errore di comunicazione col server';
                break;
            }

            EventBus.$emit('draft-error', { msg: msg });
          });
      });
    },

    submit() {
      var me = this;
      me.$v.$touch();
      me.$nextTick(() => me.focusFirstStatus());
      if (!me.$v.$invalid) {
        me.$el.querySelector('[type=submit]').setAttribute('disabled', true);
        for (let k in me.localProject) {
          me.$set(me.localProject[k], 'remoteError', '');
        }
        if (!window.PDB) {
          // Not in PDB, add Authorization header
          axios.defaults.headers.common['Authorization'] =
            'Token 427ac565f2cbda2371026e17af9394e9281a11fb';
        }

        me.getFormData().then(formData => {
          formData.set('is_published', true);

          axios
            .post(me.saveProjectUrl, formData, {
              //headers: {
              //  'Content-Type': 'multipart/form-data'
              //}
            })
            .then(function(response) {
              me.sentData = true;
              me.$emit('success');
            })
            .catch(function(error) {
              if (!!error.response && !!error.response.data) {
                if (!!error.response.data.detail) {
                  me.globalErrorMsg = error.response.data.detail;
                } else {
                  try {
                    let errors = JSON.parse(error.response.data.error);
                    if (!!errors.detail) {
                      me.globalErrorMsg = errors.detail;
                    } else {
                      for (let k in errors) {
                        let v = errors[k];
                        me.$set(
                          me.localProject[k],
                          'remoteError',
                          v.join('<br>')
                        );
                      }
                    }
                  } catch (e) {
                    console.log(e);
                    if (typeof error.response.data.error === 'string') {
                      me.globalErrorMsg = error.response.data.error;
                    } else {
                      me.globalErrorMsg = me.defaultErrorMsg;
                    }
                  }
                }
              } else {
                me.globalErrorMsg = me.defaultErrorRequest;
              }
            })
            .finally(function() {
              if (!!me.$el.querySelector('[type=submit]')) {
                me.$el
                  .querySelector('[type=submit]')
                  .removeAttribute('disabled');
              }
            });
        });
      }
    },

    createFile(key, filename) {
      let name = filename.substr(filename.lastIndexOf('/') + 1);

      let blob = new Blob(),
        file = new File([blob], name);
      return file;
    }
  },
  validations() {
    var obj = {};
    Object.keys(this.localProject).forEach(k => {
      let o = {},
        v = this.project[k].validate;

      if (!!v.required) {
        o[k] = { ...o[k], required };
        obj = { ...obj, ...o };
      }
      if (!!v.email) {
        o[k] = { ...o[k], email };
        obj = { ...obj, ...o };
      }
      if (!!v.integer) {
        o[k] = { ...o[k], integer };
        obj = { ...obj, ...o };
      }

      if (!!v.numeric) {
        o[k] = { ...o[k], numeric };
        obj = { ...obj, ...o };
      }

      if (!!v.checkIfSet) {
        o[k] = { ...o[k], checkIfSet };
        obj = { ...obj, ...o };
      }

      if (!!v.maxLength) {
        o[k] = { ...o[k], maxLength: maxLength(v.maxLength) };
        obj = { ...obj, ...o };
      }

      if (!!v.maxValue) {
        o[k] = { ...o[k], maxValue: maxValue(v.maxValue) };
        obj = { ...obj, ...o };
      }

      if (!!v.sameAs) {
        //o[k] = { sameAs: sameAs(() => v.sameAs.sameAs) }
        //obj = {...obj, ...o};
      }

      if (!!v.regex) {
        o[k] = { ...o[k], regex: regexValidator(new RegExp(v.regex)) };
        obj = { ...obj, ...o };
      }

      if (!!v.maxFileSize) {
        o[k] = { ...o[k], maxFileSize: fileSize(v.maxFileSize) };

        obj = { ...obj, ...o };
      }

      if (!!v.requiredIf) {
        o[k] = {
          ...o[k],
          requiredIf: requiredIf(form => {
            return this[v.requiredIf.fieldName] === v.requiredIf.value;
          })
        };

        obj = { ...obj, ...o };
      }
    });

    // obj['policy'] = { sameAs: sameAs(()=>true)}
    obj['accept_rule'] = { sameAs: sameAs(() => true) };

    return obj;
  },
  created() {
    let obj = {},
      localProject = {};

    Object.keys(this.project).forEach(k => {
      let p = {};
      p[k] = this.project[k];
      localProject = { ...localProject, ...p };
    });

    this.localProject = localProject;
  },
  mounted() {
    EventBus.$on('save-draft', this.saveDraft);
    const urlParams = new URLSearchParams(window.location.search),
      uuid = urlParams.get('uuid');

    this.project.uuid.value = !!uuid ? uuid : '';

    if (!!uuid) {
      axios
        .get(
          `${this.getViewUrl.replace(
            '<slug>',
            !!this.project.uuid.value ? this.project.uuid.value : ''
          )}`
        )
        .then(async response => {
          if (!!response.data.birthdate) {
            response.data.birthdate = moment(response.data.birthdate).toDate();
          }

          if (!!response.data.budget_required) {
            let s = response.data.budget_required;
            response.data.budget_required = s.substr(0, s.indexOf('.'));
          }

          await this.setProjectValues(response.data);
          Object.keys(response.data).forEach(k => {
            switch (k) {
              case 'file_1':
              case 'file_2':
              case 'file_3':
              case 'file_4':
              case 'budget_prospectus':
                if (!!response.data[k]) {
                  // this.createFile(k, response.data[k])
                  this[k] = {
                    name: response.data[`name_${k}`],
                    ghost: true,
                    file: this.createFile(k, response.data[k])
                  };
                  this[`name_${k}`] = response.data[`name_${k}`];
                }
                break;
              default:
                this[k] = response.data[k];
                break;
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import (reference) '~@less/_variables';
@import (reference) '~@less/common';
</style>